'use strict';
import './styles/global.scss';

import './scripts/modules/global.js';
import { initHeroLogos } from './scripts/modules/hero-logos.js';
import { initProblemDecoration } from './scripts/modules/problem-decoration.js';
import { initTrustDecoration } from './scripts/modules/trust-decoration.js';
import { initSolutionHubAnimation } from './scripts/modules/solution-hub-animation.js';
import { initHistoryValuesHubAnimation } from './scripts/modules/history-values-hub-animation.js';
import { initBeforeAfterSections } from './scripts/modules/before-after-category-tabs.js';
import { initBeforeAfterStatsAnimation } from './scripts/modules/before-after-stats-animation.js';
import { initBeforeAfterChartSliders } from './scripts/modules/before-after-chart-slider.js';
import { initBeforeAfterChartPairs } from './scripts/modules/before-after-chart-pairs.js';
import { initTestimonialsSwiper } from './scripts/modules/testimonials-swiper.js';
import { initClientTestimonialsSwiper } from './scripts/modules/client-testimonials-swiper.js';
import { initCssModeSnapGuard } from './scripts/modules/css-mode-snap-guard.js';
import { initPricingPlansEqualize } from './scripts/modules/pricing-plans-equalize.js';
import { initPricingDecoration } from './scripts/modules/pricing-decoration.js';
import { initIndustriesSwiper } from './scripts/modules/industries-swiper.js';
import { initCaseStudiesSwiper } from './scripts/modules/case-studies-swiper.js';
import { initCaseStudiesPageHeroQuotes } from './scripts/modules/case-studies-page-hero-quotes.js';
import { initCaseStudiesTestimonialsSwiper } from './scripts/modules/case-studies-testimonials-swiper.js';
import { initCaseStudyDetailToc } from './scripts/modules/case-study-detail-toc.js';
import { initCaseStudyDetailRelatedSwiper } from './scripts/modules/case-study-detail-related-swiper.js';
import { initCsGridCardVideoModal } from './scripts/modules/cs-grid-card-video-modal.js';
import { initCsGridSwiper } from './scripts/modules/cs-grid-swiper.js';
import { initVideoDecoration } from './scripts/modules/video-decoration.js';
import { initVideoSectionPlayer } from './scripts/modules/video-section-player.js';
import { initAboutOrbitAnimation } from './scripts/modules/about-orbit-animation.js';
import { initAboutDecoration } from './scripts/modules/about-decoration.js';
import { initAboutSignatureDraw } from './scripts/modules/about-signature-draw.js';
import { initBlogSwiper } from './scripts/modules/blog-swiper.js';
import { initProcessHubAnimation } from './scripts/modules/process-hub-animation.js';
import { initProcessReadMorePopover } from './scripts/modules/process-read-more-popover.js';
import { initStatsCountUp } from './scripts/modules/stats-count-up.js';
import { initFaqAccordion } from './scripts/modules/faq-accordion.js';
import { initServicesCapabilitiesConnectors } from './scripts/modules/services-capabilities-connectors.js';
import { initServicesCapabilitiesAnimation } from './scripts/modules/services-capabilities-animation.js';
import { initServicesFaqSections } from './scripts/modules/services-faq-tabs.js';
import { initCtaHoverAnimation } from './scripts/modules/cta-hover-animation.js';
import { initCtaBannerScrollAnimation } from './scripts/modules/cta-banner-scroll-animation.js';
import { initQuotePopup, initQuoteClamp, initQuoteExpand } from './scripts/modules/quote-popup.js';
import { initPricingRevealAnimation } from './scripts/modules/pricing-reveal-animation.js';
import { initAboutJourneyLineDraw } from './scripts/modules/about-journey-line-draw.js';
import { initExitIntentPopup } from './scripts/modules/exit-intent-popup.js';
import { initBlogListingFilter } from './scripts/modules/blog-listing-filter.js';
import { initAnchorScroll } from './scripts/modules/anchor-scroll.js';
import { initFormSpamGuard } from './scripts/modules/form-spam-guard.js';

initHeroLogos();
initProblemDecoration();
initTrustDecoration();
initSolutionHubAnimation();
initHistoryValuesHubAnimation();
initBeforeAfterSections();
initBeforeAfterStatsAnimation();
initBeforeAfterChartSliders();
initBeforeAfterChartPairs();
initTestimonialsSwiper();
initClientTestimonialsSwiper();
initCssModeSnapGuard();
initPricingPlansEqualize();
initPricingDecoration();
initIndustriesSwiper();
initCaseStudiesSwiper();
initCaseStudiesPageHeroQuotes();
initCaseStudiesTestimonialsSwiper();
initCaseStudyDetailToc();
initCaseStudyDetailRelatedSwiper();
initCsGridCardVideoModal();
initCsGridSwiper();
initVideoDecoration();
initVideoSectionPlayer();
initAboutOrbitAnimation();
initAboutDecoration();
initAboutSignatureDraw();
initBlogSwiper();
initProcessHubAnimation();
initProcessReadMorePopover();
initStatsCountUp();
initFaqAccordion();
initServicesCapabilitiesConnectors();
initServicesCapabilitiesAnimation();
initServicesFaqSections();
initCtaHoverAnimation();
initCtaBannerScrollAnimation();
initQuotePopup();
initQuoteClamp();
initQuoteExpand();
initPricingRevealAnimation();
initAboutJourneyLineDraw();
initExitIntentPopup();
initBlogListingFilter();
initAnchorScroll();
initFormSpamGuard();
